import { IconButton, Tooltip, Menu, MenuItem, Grid } from "@material-ui/core";
import Box from "@mui/material/Box";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { useContext, useEffect, useState } from "react";
import CheckPermission from "../../../helpers/Administradores/Permissions";
import PerformanceEvaluationContext from "../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import {
  createEvaluationModelModal,
  eliminaEvaluationModel,
} from "../../../context/PerformanceEvaluationContext/Actions";
import { useQuery } from "@apollo/client";
import { GET_MODEL_EVALUATION_USED_IN_EVALUATIONS } from "../../../Querys/querys";

const MenuList = (props: any) => {
  const { state, dispatch } = useContext(PerformanceEvaluationContext);
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const open = Boolean(anchorEl);
  const [disable, setDisable] = useState(false);
  const { data: getIfModelEvaluationUsedInEvaluation } = useQuery(
    GET_MODEL_EVALUATION_USED_IN_EVALUATIONS,
    {
      variables: {
        getModelEvaluationUsedInEvaluationsId: parseInt(props.id),
      },
    }
  );
  const conteo =
    getIfModelEvaluationUsedInEvaluation
      ?.GET_MODEL_EVALUATION_USED_IN_EVALUATIONS[0].conteo;
  
  const updateModel = (id: string) => {
    setAnchorEl(null);  
    createEvaluationModelModal(id, true, dispatch);
  };

  const deleteModel = (id: string) => {
    setAnchorEl(null);
    console.log("eliminado: ", id);
    console.log("ESTADO: ", state._id);
    eliminaEvaluationModel(id, true, dispatch);
  };

  useEffect(() => {
    if (
      getIfModelEvaluationUsedInEvaluation &&
      getIfModelEvaluationUsedInEvaluation?.GET_MODEL_EVALUATION_USED_IN_EVALUATIONS &&
      conteo > 0
    ) {
      console.log("el modelo esta siendo utilizado en una evaluacion");
      setDisable(true);
    } else {
      setDisable(false);
    }
  });
  return (
    <>
      <Tooltip title="Editar" placement="right">
        <Box className="IconButtonPoints" mr={2}>
          <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
            <MoreVertIcon style={{ color: "#fabb00" }} />
          </IconButton>
        </Box>
      </Tooltip>
      <Menu
        className="MoreVerIcon"
        anchorEl={anchorEl}
        open={open}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setAnchorEl(null)}
      >
        {CheckPermission("EvalDesempenio.ModelosDeEvaluacion.Editar") && (
          <MenuItem button divider onClick={() => updateModel(props.id)}>
            Editar&nbsp;
            <Grid container item justify="flex-end">
              <img src="/assets/svg/icono-editar.svg" alt="Editar" />
            </Grid>
          </MenuItem>
        )}
        {disable
          ? CheckPermission("EvalDesempenio.ModelosDeEvaluacion.Eliminar") && (
              <MenuItem button disabled>
                Eliminar&nbsp;
                <Grid container item justify="flex-end">
                  <img src="/assets/svg/icono-eliminar.svg" alt="Eliminar" />
                </Grid>
              </MenuItem>
            )
          : CheckPermission("EvalDesempenio.ModelosDeEvaluacion.Eliminar") && (
              <MenuItem button onClick={() => deleteModel(props.id)}>
                Eliminar&nbsp;
                <Grid container item justify="flex-end">
                  <img src="/assets/svg/icono-eliminar.svg" alt="Eliminar" />
                </Grid>
              </MenuItem>
            )}
      </Menu>
    </>
  );
};

export default MenuList;
